import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteMaterial } from "./learningAPI";
import swal from 'sweetalert';
export interface DeleteMaterialState {
  deleteMaterial: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DeleteMaterialState = {
    deleteMaterial: [],
  status: "idle",
};

export const GetDeleteMaterial = createAsyncThunk(
  "DeleteMaterial/fetchDeleteMaterial",
  async (data:any) => {
    const response = await fetchDeleteMaterial(data);
    return response;
  }
);

export const DeleteMaterialSlice = createSlice({
  name: "DeleteMaterial",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteMaterial.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteMaterial.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteMaterial.fulfilled, (state, action) => {
        state.status = "idle";
        state.deleteMaterial = action.payload;
        swal("Record delete success!",  "success");
      });
  },
});

export const {} = DeleteMaterialSlice.actions;

export const selectDeleteMaterial = (state: RootState) => {
  return state.DeleteMaterial.deleteMaterial;
};

export default DeleteMaterialSlice.reducer;
